export default __webpack_public_path__ + "static/media/Wednesday_00.d223299e.png";